export default class JubileeAwardService {
  constructor(http) {
    this.http = http;
  }

  async findJubileeAwardWithDatesClassByConditions(queryConditions = {}) {
    // conditions 객체를 쿼리 문자열로 변환
    // console.log("regi conditions", conditions);
    const queryParams = Object.entries(queryConditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    // console.log("queryParams", queryParams);
    return this.http.fetch(
      `/api/jubileeaward/read-award-with-dates-class?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  async createJubileeAward(jubileeAwardInfo) {
    return this.http.fetch(`/api/jubileeaward/create`, {
      method: "POST",
      body: JSON.stringify(jubileeAwardInfo),
    });
  }

  async updateJubileeAward(jubileeAwardInfo) {
    return this.http.fetch(`/api/jubileeaward/update`, {
      method: "PUT",
      body: JSON.stringify(jubileeAwardInfo),
    });
  }
}
